import React, { useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";

interface AddStickyNoteProps {
  text: string;
  onDelete: () => void;
  onEdit: () => void;
}
export const AddStickyNote = ({ text, onDelete, onEdit }: AddStickyNoteProps) => {
  const { isEditable } = useContext(CreateArtifactContext);
  return (
    <div className="relative flex items-center justify-center bg-yellow-300 rounded-lg shadow-md w-[290px] h-[290px] px-5">
      {isEditable && (
        <div>
          <div className="absolute content-center w-5 h-5 align-middle shadow-md top-1 right-1 rounded-3xl bg-slate-600">
            <button className="absolute top-0 left-0 right-0 w-5 h-5 text-white " onClick={onDelete}>
              ×
            </button>
          </div>
          <div className="absolute content-center w-5 h-5 align-middle shadow-md top-8 right-1 rounded-3xl bg-slate-600">
            <button className="relative flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600" onClick={onEdit}>
              ✎
            </button>
          </div>
        </div>
      )}

      <p className="align-middle font-black text-xl content-center gap-[30dp]">
        <pre
          className="max-w-full p-2 overflow-auto break-words whitespace-pre-wrap rounded-md"
          style={{ fontFamily: "inherit", fontSize: "inherit" }}
        >
          {text}
        </pre>
      </p>
    </div>
  );
};
